import { createContext } from 'react'

import { Store } from './types'
import { memoryStore } from './memoryStore'
import { localStorageStore } from './localStorageStore'

const defaultStore = localStorageStore()

export const StoreContext = createContext<Store>(defaultStore)
